import React from 'react';
// Shared imports
import settings from '../../../../settings';

class SoundItem extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isPlaying: false
        };
    }

    componentDidMount = () => {
        const { entry } = this.props;
        const howl = entry.get();

        howl.on('play', this.onSoundPlay);
        howl.on('end', this.onSoundStop);
        howl.on('stop', this.onSoundStop);
    };

    componentWillUnmount = () => {
        const { entry } = this.props;
        const howl = entry.get();

        howl.off('play', this.onSoundPlay);
        howl.off('end', this.onSoundStop);
        howl.off('stop', this.onSoundStop);
    };

    onSoundPlay = () => {
        this.setState({ isPlaying: true });
    };

    onSoundStop = () => {
        const { isPlaying } = this.state;
        if (isPlaying) {
            this.setState({ isPlaying: false });
        }
    };

    getContent = () => {
        const { isPlaying } = this.state;
        const { entry } = this.props;

        const icon = (
            isPlaying 
            ? "stop"
            : "play"
        );

        return (
            <>
                <span>{entry.name}</span>
                <button type="button" onClick={this.toggleSound}>
                    <img src={`${settings.assetsPath}img/${icon}-audio.png`} alt={`${icon} audio`} />
                </button>
            </>
        );
    };

    toggleSound = () => {
        const { entry } = this.props;
        const howl = entry.get();

        if (howl.playing()) {
            howl.stop();
        } else {
            howl.play();
        }
    };

    checkIfCurrent = () => {
        const { entry, currentAsset } = this.props;
        const { id } = entry;

        return id === currentAsset;
    };

    handlePickAsset = () => {
        const { onPickAsset, entry } = this.props;
        const { id } = entry;
        onPickAsset(id);
    };

    render = () => {
        // Check if this item is the selected item.
        const isActive = this.checkIfCurrent() ? 'active' : '';

        return (
            <div className={`asset-picker-item asset-picker-sound ${isActive}`} onClick={this.handlePickAsset}>
                {this.getContent()}
            </div>
        );
    };
}

SoundItem.defaultProps = {
    entry: {},
    currentAsset: ''
};

export default SoundItem;
